const WEBKIT_ENGINE = {
  V200: '2.0.0',
  V_2: '2',
};

const DEEPLINKS = {
  ML: 'meli://webview/',
  MP: 'mercadopago://webview/',
};

const ERROR_UX = {
  CODE: '37',
  TEAM: 'CRD',
};

module.exports = {
  WEBKIT_ENGINE,
  DEEPLINKS,
  ERROR_UX,
};
